import { connect } from 'react-redux';
import { getCurrentModal } from '../../../Modals/redux/selectors';
import { getHasUnreadContent } from '../../../NetworkBar/redux/selectors';
var mapStateToProps = function (state) { return ({
    isModalOpen: !!getCurrentModal(state),
    showUnreadIndicator: getHasUnreadContent(state),
}); };
export default connect(mapStateToProps);
//# sourceMappingURL=BurgerMenu.container.js.map